import React from "react";
import {css, cx} from "@panda/css";

import {DsTooltip} from "@pg-design/floating-module";
import {Message} from "@pg-design/message-module";
import {Text} from "@pg-design/text-module";

import {offerUspIcons} from "../../constants/offer_usp_icons";
import {IOfferListUsp} from "../../types/IOfferListUsp";

interface IProps {
    usp: IOfferListUsp;
}

export const OfferBoxUspChip = (props: IProps) => {
    const {usp} = props;
    const Icon = usp.icon ? offerUspIcons[usp.icon] : undefined;
    const chipClassName = cx(chipStyle, usp.variant === "promo" ? promoVariantStyle : defaultVariantStyle);

    const chipContent = (
        <>
            {Icon && <Icon size="1.6" />}
            <Text variant="info_txt_1" as="span" strong noWrap color="var(--colors-secondary)">
                {usp.label}
            </Text>
        </>
    );

    const tooltipItems = usp.tooltipItems ?? [];
    const hasTooltip = Boolean(usp.description) || tooltipItems.length > 0;

    // No tooltip content → static chip.
    if (!hasTooltip) {
        return <span className={chipClassName}>{chipContent}</span>;
    }

    // DsTooltip (hover on desktop, click on mobile). The outer wrapper stops click propagation so a
    // tap on the chip opens the tooltip instead of navigating to the offer. The tooltip shows the
    // full POI list of the pill's category (name + distance), or a plain description (mock/API).
    const tooltipContent = (
        <Message type="info" className={tooltipMessageStyle}>
            {tooltipItems.length > 0 ? (
                <div className={tooltipListStyle}>
                    {tooltipItems.map((item) => (
                        <Text key={`${item.name}-${item.distance}`} variant="info_txt_1">
                            {item.name} — {item.distance} m
                        </Text>
                    ))}
                </div>
            ) : (
                <Text variant="info_txt_1">{usp.description}</Text>
            )}
        </Message>
    );

    return (
        <DsTooltip popover={tooltipContent} type="info" placement="top" zIndex={10}>
            {({refs, getReferenceProps}) => (
                <span className={tooltipTriggerStyle} onClick={(event) => event.stopPropagation()}>
                    <span ref={refs.setReference} className={chipClassName} {...getReferenceProps()}>
                        {chipContent}
                    </span>
                </span>
            )}
        </DsTooltip>
    );
};

const chipStyle = css({
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 1,
    height: "2.4rem",
    px: 1,
    borderRadius: 1,
    userSelect: "none",
    whiteSpace: "nowrap",
    flexShrink: 0
});

const promoVariantStyle = css({backgroundColor: "#F3E7F6"});
const defaultVariantStyle = css({backgroundColor: "#F6F3F0"});

const tooltipTriggerStyle = css({
    display: "inline-flex",
    flexShrink: 0
});

// Mirrors @pg-design DsTooltip's `.message` (padding + max-width) without importing the package's
// raw .module.css (which jest can't transform when imported by deep path).
const tooltipMessageStyle = css({
    py: 3,
    px: 4,
    maxWidth: "30rem"
});

const tooltipListStyle = css({
    display: "flex",
    flexDirection: "column",
    gap: 0.5
});
import React from "react";
import {css, cx} from "@panda/css";

import {DsTooltip} from "@pg-design/floating-module";
import {Message} from "@pg-design/message-module";
import {Text} from "@pg-design/text-module";

import {offerUspIcons} from "../../constants/offer_usp_icons";
import {IOfferListUsp} from "../../types/IOfferListUsp";

interface IProps {
    usp: IOfferListUsp;
}

export const OfferBoxUspChip = (props: IProps) => {
    const {usp} = props;
    const Icon = usp.icon ? offerUspIcons[usp.icon] : undefined;
    const chipClassName = cx(chipStyle, usp.variant === "promo" ? promoVariantStyle : defaultVariantStyle);

    const chipContent = (
        <>
            {Icon && <Icon size="1.6" />}
            <Text variant="info_txt_1" as="span" strong noWrap color="var(--colors-secondary)">
                {usp.label}
            </Text>
        </>
    );

    const tooltipItems = usp.tooltipItems ?? [];
    const hasTooltip = Boolean(usp.description) || tooltipItems.length > 0;

    // No tooltip content → static chip.
    if (!hasTooltip) {
        return <span className={chipClassName}>{chipContent}</span>;
    }

    // DsTooltip (hover on desktop, click on mobile). The outer wrapper stops click propagation so a
    // tap on the chip opens the tooltip instead of navigating to the offer. The tooltip shows the
    // full POI list of the pill's category (name + distance), or a plain description (mock/API).
    const tooltipContent = (
        <Message type="info" className={tooltipMessageStyle}>
            {tooltipItems.length > 0 ? (
                <div className={tooltipListStyle}>
                    {tooltipItems.map((item) => (
                        <Text key={`${item.name}-${item.distance}`} variant="info_txt_1">
                            {item.name} — {item.distance} m
                        </Text>
                    ))}
                </div>
            ) : (
                <Text variant="info_txt_1">{usp.description}</Text>
            )}
        </Message>
    );

    return (
        <DsTooltip popover={tooltipContent} type="info" placement="top" zIndex={10}>
            {({refs, getReferenceProps}) => (
                <span className={tooltipTriggerStyle} onClick={(event) => event.stopPropagation()}>
                    <span ref={refs.setReference} className={chipClassName} {...getReferenceProps()}>
                        {chipContent}
                    </span>
                </span>
            )}
        </DsTooltip>
    );
};

const chipStyle = css({
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 1,
    height: "2.4rem",
    px: 1,
    borderRadius: 1,
    userSelect: "none",
    whiteSpace: "nowrap",
    flexShrink: 0
});

const promoVariantStyle = css({backgroundColor: "#F3E7F6"});
const defaultVariantStyle = css({backgroundColor: "#F6F3F0"});

const tooltipTriggerStyle = css({
    display: "inline-flex",
    flexShrink: 0
});

// Mirrors @pg-design DsTooltip's `.message` (padding + max-width) without importing the package's
// raw .module.css (which jest can't transform when imported by deep path).
const tooltipMessageStyle = css({
    py: 3,
    px: 4,
    maxWidth: "30rem"
});

const tooltipListStyle = css({
    display: "flex",
    flexDirection: "column",
    gap: 0.5
});
